import { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ButtonGroup,
  Text,
  ShareExternalIcon,
} from '@frontend/legacy-components';

import {
  resendSesVerificationEmail,
  sesVerificationFailureModal,
} from './data/actions';
import { isSesVerificationFailureModalOpen } from './data/reducer';

const SesVerificationFailureModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isSesVerificationFailureModalOpen);
  const cancelButtonRef = useRef<HTMLButtonElement>(null);

  const handleClose = useCallback(() => {
    dispatch(sesVerificationFailureModal.close());
  }, [dispatch]);

  const handleResend = useCallback(() => {
    dispatch(resendSesVerificationEmail.request());
  }, [dispatch]);

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={handleClose}
      leastDestructiveRef={cancelButtonRef}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader>SES email verification failed</AlertDialogHeader>
          <AlertDialogBody>
            <Text>
              The verification may have expired.
              <br />
              Select{' '}
              <Text fontWeight="medium" as="span">
                Resend verification
              </Text>{' '}
              to resend the SES email.
            </Text>
            <Button
              as="a"
              variant="link"
              size="md"
              href="https://help.paperlessparts.com/s/article/improving-email-deliverability"
              target="_blank"
              rel="noopener noreferrer"
              icon={<ShareExternalIcon />}
            >
              Learn more about SES email verification
            </Button>
          </AlertDialogBody>
          <AlertDialogFooter>
            <ButtonGroup>
              <Button
                variant="secondary"
                ref={cancelButtonRef}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={handleResend}>
                Resend verification
              </Button>
            </ButtonGroup>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default SesVerificationFailureModal;
